export default "__VITE_ASSET__CmmeDcpq__"